var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Animation_tempVar;
export default class Animation {
    constructor({ asset, sprite, frameRate, totalFrames, range, flip, position, hidden }) {
        var _a, _b;
        this.type = "animation";
        this.sprite = { width: 0, height: 0 };
        _Animation_tempVar.set(this, [0, 0, 0, 0, false]);
        this.asset = asset;
        this.sprite.width = (_a = sprite === null || sprite === void 0 ? void 0 : sprite.width) !== null && _a !== void 0 ? _a : 0;
        this.sprite.height = (_b = sprite === null || sprite === void 0 ? void 0 : sprite.height) !== null && _b !== void 0 ? _b : 0;
        this.frameRate = frameRate !== null && frameRate !== void 0 ? frameRate : 0;
        this.totalFrames = totalFrames !== null && totalFrames !== void 0 ? totalFrames : 0;
        this.range = range;
        this.flip = flip;
        this.position = position;
        this.hidden = hidden;
    }
    getLocalFrame(frame, totalFrames, looping = false) {
        if (!this.range) {
            return { localFrame: looping ? frame % totalFrames : Math.min(frame, totalFrames - 1), animating: looping || frame < totalFrames };
        }
        const rsize = this.range[1] - this.range[0] + 1;
        const f = looping ? frame % rsize : Math.min(frame, rsize - 1);
        return { localFrame: this.range[0] + f, animating: looping || frame < rsize };
    }
    getCrop(frame, looping = false) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const naturalWidth = (_b = (_a = this.asset) === null || _a === void 0 ? void 0 : _a.image.naturalWidth) !== null && _b !== void 0 ? _b : 0;
        const naturalHeight = (_d = (_c = this.asset) === null || _c === void 0 ? void 0 : _c.image.naturalHeight) !== null && _d !== void 0 ? _d : 0;
        const spriteWidth = (_f = (_e = this.sprite) === null || _e === void 0 ? void 0 : _e.width) !== null && _f !== void 0 ? _f : 0;
        const spriteHeight = (_h = (_g = this.sprite) === null || _g === void 0 ? void 0 : _g.height) !== null && _h !== void 0 ? _h : 0;
        const numCols = spriteWidth ? naturalWidth / spriteWidth : 1;
        const numRows = spriteHeight ? naturalHeight / spriteHeight : 1;
        const totalFrames = this.totalFrames || numCols * numRows;
        const { localFrame, animating } = this.getLocalFrame(frame, totalFrames, looping);
        const col = localFrame % numCols;
        const row = Math.floor(localFrame / numCols);
        __classPrivateFieldGet(this, _Animation_tempVar, "f")[0] = col * spriteWidth;
        __classPrivateFieldGet(this, _Animation_tempVar, "f")[1] = row * spriteHeight;
        __classPrivateFieldGet(this, _Animation_tempVar, "f")[2] = spriteWidth;
        __classPrivateFieldGet(this, _Animation_tempVar, "f")[3] = spriteHeight;
        __classPrivateFieldGet(this, _Animation_tempVar, "f")[4] = looping || animating;
        return __classPrivateFieldGet(this, _Animation_tempVar, "f");
    }
    getFrame(timestamp, startTime) {
        const timeEllapsed = timestamp - (startTime !== null && startTime !== void 0 ? startTime : 0);
        const frame = timeEllapsed && (this === null || this === void 0 ? void 0 : this.frameRate) ? Math.floor(this.frameRate * timeEllapsed / 1000) : 0;
        return frame;
    }
    getTotalFrames() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (this.totalFrames) {
            return this.totalFrames;
        }
        if (this.range) {
            return (this.range[1] - this.range[0]) + 1;
        }
        const naturalWidth = (_b = (_a = this.asset) === null || _a === void 0 ? void 0 : _a.image.naturalWidth) !== null && _b !== void 0 ? _b : 0;
        const naturalHeight = (_d = (_c = this.asset) === null || _c === void 0 ? void 0 : _c.image.naturalHeight) !== null && _d !== void 0 ? _d : 0;
        const spriteWidth = (_f = (_e = this.sprite) === null || _e === void 0 ? void 0 : _e.width) !== null && _f !== void 0 ? _f : 0;
        const spriteHeight = (_h = (_g = this.sprite) === null || _g === void 0 ? void 0 : _g.height) !== null && _h !== void 0 ? _h : 0;
        const numCols = spriteWidth ? naturalWidth / spriteWidth : 1;
        const numRows = spriteHeight ? naturalHeight / spriteHeight : 1;
        return numCols * numRows;
    }
    toJSON() {
        return {
            type: this.type,
            asset: this.asset,
            sprite: this.sprite,
            frameRate: this.frameRate,
            totalFrames: this.totalFrames,
            range: this.range,
            flip: this.flip,
        };
    }
}
_Animation_tempVar = new WeakMap();
